import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Checkbox, FormControlLabel, Grid, Button, Paper, Menu, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from './store/actions';
import * as validatorActions from '../../components/validator/store/actions';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';

const styles = theme => ({
    labelContainer: {
        border: '1px solid',
        borderRadius: '4px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        "&:hover": {
            borderColor: 'rgba(0, 0, 0, 0.87) !important'
        },
    },
    labelContainerFocus: {
        border: '2px solid',
        borderRadius: '4px',
        borderColor: '#0074D9',
    }
});

class ContentLabelForm extends Component {
    state = { labelSearch: '', focus_active: false, menuOpen: false, new_label_count: 0 }

    handleInputChange = (value) => {
        this.setState({ labelSearch: value });
        if (value.length >= 2) {
            this.setState({ menuOpen: true })
        }
        else {
            this.setState({ menuOpen: false })
        }
    }

    handleLabelSelect = (label) => {
        this.setState({ labelSearch: '', focus_active: false, menuOpen: false });
        return this.props.updateFunction({ labels: this.props.baseComponent.labels.concat([label]) })
    }

    handleCreateLabel = (labelName) => {
        const new_label = {
            content_label_id: "new_" + this.state.new_label_count,
            LabelName: labelName,
            LabelDescription: '',
            LabelColor: '#7FDBFF'
        }
        this.setState({ labelSearch: '', focus_active: false, menuOpen: false, new_label_count: this.state.new_label_count + 1 });
        return this.props.updateFunction({ labels: this.props.baseComponent.labels.concat([new_label]) })
    }

    handleLabelDelete = (deleted_label) => {
        this.setState({ labelSearch: '', focus_active: false, menuOpen: false });
        return this.props.updateFunction({ labels: this.props.baseComponent.labels.filter(label => label.content_label_id !== deleted_label.content_label_id) })
    }

    filteredList = () => {
        const taken_ids = this.props.baseComponent.labels.map(label => label.content_label_id);
        const filtered_list = this.props.labelList.filter(label => !taken_ids.includes(label.content_label_id))
        return filtered_list.filter(item => !this.state.labelSearch || item.LabelName.toLowerCase().includes(this.state.labelSearch.toLowerCase()))
    }

    render() {
        const { classes, theme, labelList, component_reference, component_reference_id, baseComponent, updateFunction } = this.props;
        return (
            <Grid item xs={6}>
                <Typography variant={'h5'}>Tags</Typography>
                <div className={this.state.focus_active ? classes.labelContainerFocus : classes.labelContainer}>
                    {this.props.baseComponent.labels.map(label => {
                        if (this.props.view_type === 'detail') {
                            return (
                                <Chip key={label.content_label_id} style={{ margin: '5px', backgroundColor: label.LabelColor }} label={label.LabelName} />
                            )
                        }
                        return (
                            <Chip key={label.content_label_id} style={{ margin: '5px', backgroundColor: label.LabelColor }} label={label.LabelName} onDelete={() => this.handleLabelDelete(label)} />
                        )
                    })}
                    {this.props.view_type === 'detail' ?
                        null
                        :
                        <TextField
                            id="labelSearch"
                            style={{ marginLeft: '5px', marginTop: '4px', width: '100%', position: 'static' }}
                            // label="Labels"
                            value={this.state.labelSearch}
                            onFocus={() => this.setState({ focus_active: true })}
                            onBlur={() => this.setState({ focus_active: false })}
                            onChange={(e) => this.handleInputChange(e.target.value)}
                            InputProps={{ disableUnderline: true }}
                        />
                    }

                </div>
                {this.state.menuOpen ?
                    <div>
                        <Paper>
                            <MenuList>
                                <MenuItem onClick={() => this.handleCreateLabel(this.state.labelSearch)} >{`Create '${this.state.labelSearch}'`}</MenuItem>
                                {this.filteredList().map(label => {
                                    return (
                                        <MenuItem key={label.content_label_id} onClick={() => this.handleLabelSelect(label)}>{label.LabelName}</MenuItem>
                                    )
                                })}
                            </MenuList>
                        </Paper>
                    </div>
                    : null
                }
            </Grid>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ auth, validator }) {
    return {
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ContentLabelForm)));



// WEBPACK FOOTER //
// src/main/content/content_label/ContentLabelForm.js